import { useEffect, useState } from "react";

type Theme = "default" | "dark";
export type UseDarkModeReturn = [Theme, () => void, boolean];

export const useDarkMode = (): UseDarkModeReturn => {
    const [theme, setTheme] = useState<Theme>("default");
    const [componentMounted, setComponentMounted] = useState(false);

    const setMode = (mode: Theme): void => {
        window.localStorage.setItem("theme", mode);
        setTheme(mode);
    };

    const toggleTheme = (): void => {
        if (theme === "default") {
            setMode("dark");
        } else {
            setMode("default");
        }
    };

    useEffect(() => {
        const localTheme = window.localStorage.getItem("theme") as Theme;

        if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches && !localTheme) {
            setMode("dark");
        } else if (localTheme) {
            setTheme(localTheme);
        } else {
            setMode("default");
        }

        setComponentMounted(true);
    }, []);

    return [theme, toggleTheme, componentMounted];
};
